import React from 'react';
import { useGetOffersQuery } from '../../Offers/Service/offersApi';
import { mapBookingOffersLookupData } from './offersLookupApi.contract';

export const useGetBookingOffersLookupQuery = () => {
  const queryResult = useGetOffersQuery();

  const data = React.useMemo(() => mapBookingOffersLookupData(queryResult.data), [queryResult.data]);

  return {
    ...queryResult,
    data,
  };
};
